import { compose } from 'recompose'
import { withLocalizationErrorMessage } from 'hocs/withLocalizationErrorMessage'
import { normalizeEvents } from 'hocs/normalizeEvents'
import Select from './Select'

export default compose(
  withLocalizationErrorMessage,
  normalizeEvents,
)(Select)
